import React, { useState } from 'react';
import styled from 'styled-components';
import { Form, Input, Checkbox, Button } from 'antd';
import axios from 'axios';

const MultifactorVerification = (props) => {

  const [disabled, setDisabled] = useState(true);
  const [starting, setStarting] = useState(false);

  const [form] = Form.useForm();

  const backToLogin = () => {

    localStorage.removeItem('sessionId')
    axios.get('/api/authentication/logout');

    props.$location.replace();
    props.$location.url('/');
    props.$rootScope.$apply();
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };

  const handleSubmit = values => {

    setStarting(true);
    setDisabled(true);

    axios.post('/api/multifactor/verify', {  }).then((res) => {
      setStarting(false);
      setDisabled(false);
    })
    .catch(error => {
      setStarting(false);
      setDisabled(false);
      alert('Error during verification!')
    })
  }

  const handleChange = (value) => {
    if (value !== '') {
      setDisabled(false);
    }
  }

  return (
    <Container>
      <Form
        form={form}
        {...formItemLayout}
        onFinish={handleSubmit}
        labelAlign="left"
      >
        <Form.Item label="Verification Code" name="verificationCode">
          <Input onChange={handleChange}/>
        </Form.Item>
        <Form.Item style={{ paddingTop: '10px', textAlign: 'left' }} name="trustDevice" valuePropName="checked">
          <Checkbox>Trust this device</Checkbox>
        </Form.Item>
        <Form.Item
          wrapperCol={{
            xs: { span: 24 },
            sm: { span: 24 },
          }}
          style={{ marginTop: '25px' }}
        >
          <Button
            type="primary"
            htmlType="submit"
            style={{ float: 'right', marginLeft: '10px' }}
            disabled={disabled}
            loading={starting}>
            Submit
          </Button>
          <Button
            style={{ float: 'right' }}
            onClick={backToLogin}>
            Cancel
          </Button>
        </Form.Item>
      </Form>
    </Container>
  );
};

const Container = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }
`

export default MultifactorVerification;